import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/default-page-layout.js";
import NoteLayout from '../components/NoteLayout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <NoteLayout mdxType="NoteLayout">
      <h1>{`point to`}</h1>
      <p>{`I have a book sitting on my desk called `}<em parentName="p">{`How to Win at College`}</em>{`—a title I would scoff at were I not already a fan of the `}<a className="external" href="https://calnewport.com" target="_blank">{`author`}</a>{`'s work. It contains a list of concise, actionable, and—in my opinion—smart tips on how to stand out without being (too) stressed out.`}</p>
      <p>{`One tip reads, "Do one thing better than anyone else you know." Whether it's baking cupcakes, playing a particular video game, or solving riddles, mastering a skill—no matter how trivial—gives you confidence. When everything else is uncertain, you at least have "one thing to feel sure of."`}</p>
      <p>{`It got me thinking. In my life, there are people I point to for being remarkable at something—so good that it's part of their identity, in a good way.`}</p>
      <p>{`My `}<a className="external" href="https://thesephist.surge.sh" target="_blank">{`Linus`}</a>{`, who I met through `}<a parentName="p" {...{
          "href": "/communities"
        }}>{`Hack Club`}</a>{`, is prolific across a mindboggling number of fields. I lived with him last summer, and amid his mystifying schedule of eating one meal a day and sleeping ?? hours a day, he built a programming language and made a piano improv video on top of his internship and work for student organizations like Cal Hacks and Dorm Room Fund.`}</p>
      <p>{`Another friend, `}<a className="external" href="https://lachlanjc.me" target="_blank">{`Lachlan`}</a>{` consistently creates websites and other projects that are high-quality and impactful. They're super opinionated about the tools they use and are always making `}<a className="external" href="https://notebook.lachlanjc.me/2019-09-24_lachlan_ultra/" target="_blank">{`big statements`}</a>{`, often while wearing their signature bright red jeans.`}</p>
      <p>{`I know others who offer a helping hand (and foot) in any situation, who brighten every moment with humor, or who are fearless activists despite controversy and `}<a parentName="p" {...{
          "href": "/leadership"
        }}>{`criticism`}</a>{`.`}</p>
      <p>{`I wonder: Who points to me, and what for? In others' lives, what am I (perceived as) (one of) the best at?`}</p>
      <p>{`Some possibilities:`}</p>
      <ul>
        <li parentName="ul">{`Doing pistol squats`}</li>
        <li parentName="ul">{`Documenting my `}<a parentName="li" {...{
            "href": "/fail"
          }}>{`failures`}</a></li>
        <li parentName="ul">{`Hitting inbox zero`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/code"
          }}>{`Making websites`}</a></li>
      </ul>
    </NoteLayout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      